var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"productImageItem"},[_c('div',{staticClass:"productWrapper"},[_c('div',{staticClass:"product"},[_c('div',{staticClass:"productInner"},[_c('AdvancedImage',{attrs:{"is-lazy-component":false,"src":_vm.product.src,"alt":_vm.product.alt,"config":_vm.productConfig,"modifier":"centered"}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }